import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import produce from 'immer';
import { orderBy } from 'lodash-es';
import { mapPharmOrder, PharmOrder, buildSubmitPharmReorderRequest } from '../../models';
import { ApiService, EnvService, SentryService } from '../../services';
import { defaultApiStoreIterableData, ApiStoreData, CcsSentryError, MissingApiRequestDataError } from '../utils';
import { SubmitPharmReorder } from './pharm-wizard-submission.actions';
import { PatientState } from '../patient/patient.state';
import { PharmWizardSubmissionStateModel } from './pharm-wizard-submission.model';
import { PharmOrdersState } from '../pharm-order/pharm-orders.state';
import { defaultApiStoreData } from '../utils';
export type PharmOrdersStateModel = ApiStoreData<PharmOrder[]>;

const defaults = {
  pharmReorderSubmission: defaultApiStoreData,
};

@State<PharmWizardSubmissionStateModel>({
  name: 'pharmOrderWizardSubmission',
  defaults,
})
@Injectable({ providedIn: 'root' })
export class PharmWizardSubmissionState {
  constructor(
    private apiService: ApiService,
    private store: Store,
    private sentry: SentryService,
    private envService: EnvService
  ) {}

  handleError = this.sentry.handleError;
  handleSuccess = this.sentry.handleSuccess;

  @Selector()
  static submitPharmReorder(state: PharmWizardSubmissionStateModel): ApiStoreData<null> {
    return state.pharmReorderSubmission;
  }

  /*

  @Selector()
  static isLoading(state: PharmOrdersStateModel): boolean {
    return state.isLoading;
  }

  @Selector()
  static error(state: PharmOrdersStateModel): CcsSentryError | null {
    return state.error;
  }
  */

  @Action(SubmitPharmReorder)
  submitPharmReorder(ctx: StateContext<PharmWizardSubmissionStateModel>, action: SubmitPharmReorder) {
    const errors: string[] = [];
    const patientId = action.patientId;
    const pharmacyLocation = action.pharmacy;
    const enterpriseOrderId = action.enterpriseOrderId;
    const customerId = action.customerId;
    const source = action.source;
    const pharmItems = action.pharmItems;

    if (!patientId) errors.push('Missing patient id');

    const body = buildSubmitPharmReorderRequest(
      pharmacyLocation!,
      patientId!,
      enterpriseOrderId!,
      pharmItems!,
      customerId!,
      source!
    );

    ctx.setState(
      produce((draft) => {
        draft.pharmReorderSubmission.isLoading = true;
      })
    );

    return this.apiService.submitPharmReorder(body).pipe(
      tap({
        next: () => {
          this.handleSuccess({ ctx, stateKey: 'pharmReorderSubmission' });
        },
      }),
      catchError(
        (error: Error): Observable<any> =>
          this.handleError({ ctx, error, stateKey: 'pharmReorderSubmission', resetData: false })
      )
    );
  }
}
